/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popFaceTip.vue?vue&type=template&id=6de38be7&scoped=true"
import script from "./popFaceTip.vue?vue&type=script&lang=js"
export * from "./popFaceTip.vue?vue&type=script&lang=js"
import style0 from "./popFaceTip.vue?vue&type=style&index=0&id=6de38be7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de38be7",
  null
  
)

export default component.exports